import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Parking(props) {
  const { height, width, iconColor } = props;

  return (
    <svg viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <path fill={iconColor} d="m12 1h-5v22h1v-8h4a7 7 0 0 0 0-14zm0 13h-4v-12h4a6 6 0 0 1 0 12z" />
    </svg>
  );
}

Parking.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Parking.defaultProps = {
  width: 18,
  height: undefined,
  iconColor: colors.iconGrey
};

export default Parking;
